import { actions, getters, mutations, state } from './modal.store.js';
export default {
	state,
	getters,
	actions,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/modal/index.js